import React from "react";

export default function AppFooter() {
  return (
    <footer className="footer py-3 border-top text-center">
      <small className="">
        © {new Date().getFullYear()} VaultSecure. All Rights Reserved.
      </small>
    </footer>
  );
}
